import { Flex, Text } from "@chakra-ui/react";
import BrandCheckIcon from "./icons/BrandCheckIcon";
import BrandTickActiveIcon from "./icons/BrandTickActiveIcon";
import BrandTickInactiveIcon from "./icons/BrandTickInactiveIcon";

type StepStatus = "completed" | "current" | "pending";

interface Step {
	label: string;
	status: StepStatus;
}

interface StepIndicatorProps {
	steps: Array<Step>;
}

const StepIndicatorIcon = ({ step }: { step: Step }) => {
	const isCompleted = step.status === "completed";
	const isCurrent = step.status === "current";
	const isPending = step.status === "pending";

	return (
		<Flex w="20px" h="20px" alignItems="center" justifyContent="center">
			{isCompleted ? (
				<BrandCheckIcon />
			) : isCurrent ? (
				<BrandTickActiveIcon />
			) : isPending ? (
				<BrandTickInactiveIcon />
			) : null}
		</Flex>
	);
};

const StepIndicatorLabel = ({ step }: { step: Step }) => {
	const isCompleted = step.status === "completed";

	return (
		<Text
			lineHeight="21px"
			fontSize="14px"
			fontWeight="500"
			color={isCompleted ? "white" : "gray.700"}
			whiteSpace="nowrap"
		>
			{step.label}
		</Text>
	);
};

const StepIndicator = ({ steps }: StepIndicatorProps) => {
	return (
		<Flex
			display="flex"
			border="solid 1px"
			borderColor="gray.200"
			borderRadius="10rem"
			overflow="hidden"
		>
			{steps.map((step, index) => {
				const isFirst = index === 0;
				const isLast = index === steps.length - 1;
				const isCompleted = step.status === "completed";

				return (
					<Flex key={step.label} alignItems="center">
						{/* Step Item */}
						<Flex
							px={4}
							py={2}
							alignItems="center"
							gap={2}
							borderLeftRadius={isFirst ? "10rem" : undefined}
							borderRightRadius={isLast ? "10rem" : undefined}
							bgColor={isCompleted ? "brand.600" : "white"}
							position="relative"
							pr={isLast ? 4 : 6}
							_after={
								!isLast
									? {
											content: '""',
											position: "absolute",
											top: 0,
											right: "-12px",
											width: 0,
											height: 0,
											borderTop: "18px solid transparent",
											borderBottom: "18px solid transparent",
											borderLeft: `12px solid ${isCompleted ? "var(--chakra-colors-brand-600)" : "white"}`,
											zIndex: 1,
										}
									: undefined
							}
							_before={
								!isLast
									? {
											content: '""',
											position: "absolute",
											top: "-1px",
											right: "-14px",
											width: 0,
											height: 0,
											borderTop: "19px solid transparent",
											borderBottom: "19px solid transparent",
											borderLeft: "14px solid var(--chakra-colors-gray-200)",
											zIndex: 0,
										}
									: undefined
							}
						>
							<StepIndicatorIcon step={step} />
							<StepIndicatorLabel step={step} />
						</Flex>
					</Flex>
				);
			})}
		</Flex>
	);
};

export default StepIndicator;
